import React from "react";
import { connect } from "react-redux";
import { Card } from "antd";


const PerformanceHeader = ( props ) => {
  const { icon, title, description, rightNav, cardTheme, children } = props;

  return (
    <Card className={`rounded-xl card-border-s ${cardTheme}`}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="icon-theme rounded-full p-2 shrink-0">
            {icon}
          </div>
          <div className="min-w-0 flex-1">
            <h4 className="text-base font-medium title-text break-words">
              {title}
            </h4>

            <p className="mt-1 text-xs muted-text">
              {description}
            </p>
          </div>
        </div>
        {rightNav && (
          <div className="self-start sm:self-center shrink-0 status-indicator emerald text-[10px]">
            {rightNav}
          </div>
        )}
      </div>
      <div className="mt-6 sm:mt-8">
        {children}
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceHeader);
